import React, { useState, lazy, Suspense } from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { CartProvider } from "./context/CartContext";
import "./App.css";

const Home = lazy(() => import("./components/Home"));
const Menu = lazy(() => import("./components/Menu"));
const About = lazy(() => import("./components/About"));
const Contact = lazy(() => import("./components/Contact"));
const PizzaBuilder = lazy(() => import("./components/PizzaBuilder"));
const Checkout = lazy(() => import("./components/Checkout"));
const Wishlist = lazy(() => import("./components/Wishlist"));

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem("darkMode") === "true";
  });

  function toggleDark() {
    setDarkMode((prev) => {
      localStorage.setItem("darkMode", !prev);
      return !prev;
    });
  }

  return (
    <CartProvider>
      <div className={darkMode ? 'app dark-app' : 'app'}>
        <Router>
          <Navbar darkMode={darkMode} toggleDark={toggleDark} />
          <main>
            <Suspense
              fallback={<div style={{ padding: '40px', textAlign: 'center' }}>Loading...</div>}
            >
              <Routes>
                <Route path="/" element={<Home darkMode={darkMode} />} />
                <Route path="/menu" element={<Menu darkMode={darkMode} />} />
                <Route path="/build" element={<PizzaBuilder darkMode={darkMode} />} />
                <Route path="/about" element={<About darkMode={darkMode} />} />
                <Route path="/contact" element={<Contact darkMode={darkMode} />} />
                <Route path="/checkout" element={<Checkout darkMode={darkMode} />} />
                <Route path="/wishlist" element={<Wishlist darkMode={darkMode} />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </Router>
      </div>
    </CartProvider>
  );
}

export default App;
